import { render, staticRenderFns } from "./LuckyRoulette.vue?vue&type=template&id=118e43b2&scoped=true"
import script from "./LuckyRoulette.vue?vue&type=script&lang=js"
export * from "./LuckyRoulette.vue?vue&type=script&lang=js"
import style0 from "./LuckyRoulette.vue?vue&type=style&index=0&id=118e43b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e43b2",
  null
  
)

export default component.exports